/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Real Estate status -> status-token variant (styles/tokens/status.js).
 * One table for every RE vocabulary; where two vocabularies share a word
 * (HANDED_OVER, ACTIVE, DRAFT) they mean the same kind of state.
 */
export const RE_STATUS_VARIANTS = {
  // units
  AVAILABLE: "success",
  HELD: "warning",
  RESERVED: "info",
  BOOKED: "info",
  SOLD: "neutral",
  HANDED_OVER: "success",
  LEASED: "info",
  BLOCKED: "error",
  // projects
  PLANNED: "neutral",
  LAUNCHED: "info",
  UNDER_CONSTRUCTION: "warning",
  COMPLETED: "success",
  ON_HOLD: "error",
  // listings
  DRAFT: "neutral",
  ACTIVE: "success",
  UNDER_OFFER: "warning",
  CLOSED: "neutral",
  EXPIRED: "error",
  WITHDRAWN: "error",
  // viewings
  SCHEDULED: "info",
  CONFIRMED: "success",
  NO_SHOW: "error",
  CANCELLED: "error",
  // broker registration, refunds
  PENDING: "warning",
  APPROVED: "success",
  SUSPENDED: "error",
  PAID: "success",
  NOT_APPLICABLE: "neutral",
};

export default RE_STATUS_VARIANTS;
